<template>
  <select ref="multi-select" :name="name" multiple="multiple">
    <option v-for="(option, index) in options" :value="option.value" :selected="optionSelected(option.value)">{{option.label}}</option>
  </select>
</template>

<script>
  export default {
    name: "multiselect",
    props: {
      options: {
        type: Array,
        default: () => {
          return [];
        }
      },
      name: {
        type: String,
        required: false
      },
      enableClickableOptGroups: {
        type: Boolean,
        default: false
      },
      enableCollapsibleOptGroups: {
        type: Boolean,
        default: false
      },
      enableSelectAllOpt: {
        type: Boolean,
        default: true
      },
      enableFiltering: {
        type: Boolean,
        default: true
      },
      buttonClass: {
        type: String,
        default: "btn btn-default left"
      },
      popupWidth: {
        type: String,
        default: "150px"
      },
      width: {
        type: String,
        default: "100%"
      },
      maxHeight: {
        type: String,
        default: "365"
      },
      optionTemplate: {
        type: Function,
        default: null
      },
      value: {}
    },
    mounted () {
      this.init();
    },
    computed: {
      optionSelected() {
        return (v) => {
          return this.value.indexOf(v) != -1;
        }
      }
    },
    watch: {
      value(val) {
        $(this.$refs["multi-select"]).multiselect('select', val);
      }
    },
    methods: {
      init() {
        let that = this;

        var selectElement = $(this.$refs["multi-select"]);

        // advanced functions
        var onchange_function = function(option, checked, select) {
          that.$emit("change");
        }
        
        var dropdownshow_function = function(event) {
          that.$emit("shown");
        }

        var dropdownhide_function = function(event) {
          that.$emit("input", selectElement.val());
          that.$emit("hidden");
        }

        let options = {
          enableClickableOptGroups: that.enableClickableOptGroups,
          enableCollapsibleOptGroups: that.enableCollapsibleOptGroups,
          enableFiltering: that.enableFiltering,
          includeSelectAllOption: that.enableSelectAllOpt,
          disableIfEmpty: true,
          dropRight: false,
          buttonWidth: that.width,
          maxHeight: that.maxHeight,
          numberDisplayed: 1,
          onChange: onchange_function,
          onDropdownShow: dropdownshow_function,
          onDropdownHide: dropdownhide_function,
          buttonClass: that.buttonClass + " v-multi-select",
          enableCaseInsensitiveFiltering: true,
          nonSelectedText: "Aucune sélection",
          allSelectedText: "Tous sélectionnés",
          filterPlaceholder: "Recherche",
          selectAllText: "Tout sélectionner",
          nSelectedText: "sélectionnés"
        };

        // init multiselect
        selectElement.multiselect(options);

        this.$nextTick(() => {

          if(this.optionTemplate != null) {
            let listItems = this.$refs["multi-select"].parentNode.querySelectorAll(`ul.dropdown-menu li`);
            for (const ix in listItems) {
              const element = listItems[ix];
              if(element.className != null && element.className.indexOf("multiselect-") === -1) {
                let cb = element.querySelector(".checkbox");
                let input = cb.querySelector("input");
                let html = this.optionTemplate(ix-2, cb.childNodes[1].textContent, input.value, cb); // index, label, value, element

                element.querySelector(".checkbox").removeChild(cb.childNodes[1]);

                let span = document.createElement("span");
                span.innerHTML = html;
                element.querySelector(".checkbox").appendChild(span);
              } else if (element.className != null && element.className.indexOf("multiselect-item multiselect-all") !== -1) {
                let cb = element.querySelector(".checkbox");
                let input = cb.querySelector("input");
                let html = this.optionTemplate(-1, cb.childNodes[1].textContent, input.value, cb); // index, label, value, element

                element.querySelector(".checkbox").removeChild(cb.childNodes[1]);

                let span = document.createElement("span");
                span.innerHTML = html;
                element.querySelector(".checkbox").appendChild(span);
              }
            }
          }

          this.$refs["multi-select"].parentNode.querySelector("ul.multiselect-container").style.minWidth = this.popupWidth;

        })
      }
    },
  }
</script>

<style lang="scss">
.v-multi-select .caret {
  position: absolute;
  top: 50%;
  margin-top: -2px;
  right: 15px;
}

.v-multi-select {
  position: relative;
}

.v-multi-select.left {
  text-align: left !important;
}

.multiselect-container {
  left: 0px !important;
}

@media all and (max-width: 767px) {
  .multiselect-container.dropdown-menu {
    margin-top: 5px;
  }
}
</style>